import React, {useEffect, useRef} from 'react';
import {gql, useQuery} from "@apollo/client";
import {getClientId} from "./types/getClientId";
import Progress from '../../../util/Progress';
import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import CenteredNotification from "../../../util/CenteredNotification";
import {ExclamationTriangleIcon} from "@radix-ui/react-icons";

const OAUTH_CLIENT_ID = gql`query getClientId {
    qqcatalyst {
        clientId
        redirectUri
    }
}`;

const ENDPOINT = 'https://login.qqcatalyst.com/oauth/authorize';

export default function OAuthInit() {
    const fired = useRef(false);

    // Get client id for oauth and redirect
    const { loading, data, error } = useQuery<getClientId>(OAUTH_CLIENT_ID);

    useEffect(() => {
        if (fired.current) return;
        if (!loading && !error && data) {
            fired.current = true;
            window.location.href = ENDPOINT +
                '?response_type=code&client_id=' + data.qqcatalyst.clientId +
                '&redirect_uri=' + encodeURIComponent(data.qqcatalyst.redirectUri) +
                '&state=';
        }
    }, [loading, data, error]);

    if (loading) {
        return <Progress>Loading ...</Progress>
    }

    if (error) {
        return (
            <CenteredNotification>
                <Alert variant="destructive">
                    <ExclamationTriangleIcon className="h-4 w-4" />
                    <AlertTitle>Authorization error</AlertTitle>
                    <AlertDescription>Error fetching client id: {error.message}</AlertDescription>
                </Alert>
            </CenteredNotification>
        );
    }

    return <Progress>Redirecting ...</Progress>
}
